import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/company")({
  beforeLoad: ({ location }) => {
    const normalized = location.pathname.replace(/\/+$/, "") || "/"
    if (normalized === "/company") {
      throw redirect({ to: "/recruit" })
    }
  },
  component: () => <Outlet />,
})
